import SvgIcon, { IconProps } from './SvgIcon';
import React from 'react';

export default function ShareIcon2(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M8 7.197s2.196-2.716 3.404-3.76a.9.9 0 0 1 .63-.239.918.918 0 0 1 .562.238C13.804 4.482 16 7.197 16 7.197m-3.966-3v11M8 11.197c-1.4 0-2.1 0-2.635.273a2.5 2.5 0 0 0-1.093 1.092C4 13.097 4 13.797 4 15.197v1c0 2.357 0 3.536.732 4.268.732.732 1.911.732 4.268.732h6c2.357 0 3.535 0 4.268-.732.732-.732.732-1.91.732-4.268v-1c0-1.4 0-2.1-.273-2.635a2.5 2.5 0 0 0-1.092-1.092c-.535-.273-1.235-.273-2.635-.273" />
    </SvgIcon>
  );
}
